var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Keypress',{attrs:{"key-event":"keydown","prevent-default":true,"multiple-keys":_vm.getMultipleKeys,"modifiers":['ctrlKey', 'metaKey', 'altKey']},on:{"success":_vm.onKeyUpSuccess,"any":_vm.onAnyKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }